import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { ThemeSettings } from "../../types/theme.js";
import { facebook, instagram, linkedin } from "../../assets/icons.js";

const Icons = {
  facebook,
  instagram,
  linkedin,
};

const Footer: React.FC = () => {
  const store = useStore<ThemeSettings>();
  const logo = store.themeSettings.footerLogo;
  const menu = store.themeSettings.footerMenu;
  const text = store.themeSettings.footerText;
  const socials = store.themeSettings.footerSocials;

  return (
    <footer>
      <div className="component">
        <div className="content mw b4">
          <div className="top">
            <div className="left">
              {logo && (
                <div className="logo">
                  <img
                    src={transformImageUrl(logo, { width: 320 })}
                    alt={logo.altText}
                  />
                </div>
              )}
            </div>
            <div className="right">
              {Array.isArray(menu) &&
                menu.map((item) => (
                  <ul key={item.id} className="menu">
                    {Array.isArray(item.links) &&
                      item.links.map((link) => (
                        <li key={link.id}>
                          {link.label && <p>{link.label}</p>}
                          {link.link && (
                            <a href={link.link.url}>{link.link.title}</a>
                          )}
                        </li>
                      ))}
                  </ul>
                ))}
            </div>
          </div>
          {(text || socials) && (
            <div className="bottom">
              <div className="left">
                {text &&
                  text.map((item, index) =>
                    item.link ? (
                      <a key={index} href={item.link.url}>
                        {item.link.title}
                      </a>
                    ) : (
                      <p key={index}>{item.text}</p>
                    )
                  )}
              </div>
              <div className="right">
                {socials &&
                  socials.map((item, index) => {
                    const Icon = item.icon ? Icons[item.icon] : null;
                    return (
                      <a key={index} href={item.link?.url}>
                        <div className="icon">{Icon}</div>
                      </a>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
